<!-- 投手天级统计 -->
<template>
  <div>
    <div :style="{ width: table_scroll_width + 'px' }">
      <div class="page_title_div">
        <div class="page-title page_title">投手天级统计</div>
        <a-select
          v-if="calcShowTeamId"
          style="position: sticky; left: 180px; width: 150px"
          v-model="team_id"
          placeholder="请选择投放团队"
          :options="putTeamList"
          allowClear
          @change="putTeamChange"
        >
        </a-select>
      </div>
      <div
        style="position: sticky; left: 30px; z-index: 5"
        :style="{ width: body_width + 'px' }"
      >
        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 10px 0 5px;
          "
        >
          <div class="screen-box">
            <div class="screen-label">日期</div>
            <a-range-picker
              style="width: 300px"
              @change="onChangeDate"
              :allowClear="false"
              :locale="locale"
              :value="[
                this.moment(startTime, dateFormat),
                this.moment(endTime, dateFormat),
              ]"
            />
          </div>

          <div
            v-if="
              filterData.hasOwnProperty('op_id') &&
              Object.keys(filterData.op_id).length > 0
            "
            class="screen-box"
          >
            <div class="screen-label">投手</div>
            <a-select
              mode="multiple"
              style="min-width: 200px"
              placeholder="请选择投手"
              @change="handleChangeA"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(item, index) in filterData.op_id.list"
                :key="index"
                :value="item.key"
              >
                {{ item.value }}
              </a-select-option>
            </a-select>
          </div>

          <div
            v-if="
              filterData.hasOwnProperty('group') &&
              Object.keys(filterData.group).length > 0
            "
            class="screen-box"
          >
            <div class="screen-label">投放小组</div>
            <a-select
              mode="multiple"
              style="min-width: 200px"
              placeholder="请选择投放小组"
              @change="handleChangeT"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(item, index) in filterData.group.list"
                :key="item.id"
                :value="item.id"
              >
                {{ item.group_name }}
              </a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">媒体平台</div>
            <a-select
              mode="multiple"
              style="min-width: 200px"
              placeholder="请选择媒体平台"
              @change="handleChangeB"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option :value="1">巨量</a-select-option>
              <a-select-option :value="2">腾讯ADQ</a-select-option>
              <a-select-option :value="4">百度</a-select-option>
              <a-select-option :value="5">快手</a-select-option>
            </a-select>
          </div>

          <a-button
            @click="searchButton('button')"
            :loading="search_button_loading"
            type="primary"
            icon="search"
            class="screen-box"
            style="margin-right: 20px"
            >搜索</a-button
          >
          <a-button
            @click="exportButton"
            :loading="down_button_loading"
            class="screen-box"
            type="primary"
            icon="download"
            >导出</a-button
          >
        </div>
      </div>
      <div class="group_div">
        <div class="disabled_div">汇总条件</div>
        <a-checkbox-group
          style="position: sticky; left: 120px"
          v-model="checkedList"
          :options="groupList"
        />
      </div>
      <div>
        <a-button
          style="
            position: sticky;
            left: 30px;
            margin-top: 16px;
            margin-bottom: 8px;
          "
          @click="showCusttomTable"
          icon="setting"
          >自定义列</a-button
        >
      </div>
    </div>

    <div>
      <!-- 表头 -->
      <div
        class="table-th"
        ref="table_th"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <div
          class="table-th-cell-sticky"
          style="display: flex; align-items: center"
        >
          <template v-for="(item, index) in rableTitle" name="item.type">
            <div
              v-if="index <= sticky_index"
              class="table-th-cell"
              style="cursor: default"
              :style="{ width: rableTitle[index].width + 'px' }"
            >
              {{ rableTitle[index].title }}
            </div>
          </template>
        </div>

        <div v-for="(item, index) in rableTitle" :key="index">
          <div
            v-if="index > sticky_index && item.show_control"
            class="table-th-cell"
            :style="{
              width: item.width + 'px',
              cursor: item.sort_control ? 'pointer' : 'default',
              'justify-content': item.text_right ? 'flex-end' : '',
            }"
            @click="sortClick(index)"
          >
            {{ item.title }}
            <div
              v-if="item.sort_control"
              style="
                display: flex;
                flex-direction: column;
                width: 12px;
                margin-left: 5px;
              "
            >
              <a-icon
                type="caret-up"
                :style="{ color: item.sort_status === 2 ? '#1890ff' : '#999' }"
                style="font-size: 12px; margin-bottom: -4px"
              />
              <a-icon
                type="caret-down"
                :style="{ color: item.sort_status === 1 ? '#1890ff' : '#999' }"
                style="font-size: 12px"
              />
            </div>
          </div>
        </div>
        <!-- 占位，隔出一个空白区域 -->
        <div id="" style="padding: 15px"></div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <div
          class="table-td-cell-sticky"
          style="display: flex; align-items: center"
        >
          <template v-for="(z_tem, z_ndex) in rableTitle">
            <div
              v-if="
                z_ndex <= sticky_index &&
                z_tem.type != 'media_platform' &&
                z_tem.type != 'plan_type'
              "
              class="table-td-cell"
              :style="{ width: rableTitle[z_ndex].width + 'px' }"
            >
              <div v-if="z_tem.type === 'admin_id'">
                {{ item.admin_name }}
              </div>
              <div v-else>
                {{ item[z_tem.type] }}
              </div>
            </div>
            <div
              v-else-if="
                z_ndex <= sticky_index && z_tem.type == 'media_platform'
              "
              class="table-td-cell"
              :style="{ width: rableTitle[z_ndex].width + 'px' }"
            >
              {{ item[z_tem.type] | mediaFilters }}
            </div>
            <div
              v-else-if="z_ndex <= sticky_index && z_tem.type == 'plan_type'"
              class="table-td-cell"
              :style="{ width: rableTitle[z_ndex].width + 'px' }"
            >
              {{ item[z_tem.type] | planFilters }}
            </div>
          </template>
        </div>

        <template v-for="(z_tem, z_ndex) in rableTitle">
          <div
            v-if="
              z_ndex > sticky_index &&
              z_tem.show_control &&
              !roiKeyList.includes(z_tem.type)
            "
            class="table-td-cell"
            :class="{ 'text-right': rableTitle[z_ndex].text_right }"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ item[z_tem.type] }}
          </div>
          <div
            v-else-if="
              z_ndex > sticky_index &&
              z_tem.show_control &&
              roiKeyList.includes(z_tem.type)
            "
            class="table-td-cell"
            :class="{ 'text-right': rableTitle[z_ndex].text_right }"
            :style="{ width: rableTitle[z_ndex].width + 'px' }"
          >
            {{ (item[z_tem.type] * 100) | tableToFixed }}%
          </div>
        </template>
      </div>

      <div
        v-if="tableShowData.length === 0"
        style="text-align: center; margin: 80px 0 50px"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <div style="width: calc(100vw - 60px); position: sticky; left: 30px">
          <a-icon style="font-size: 70px; color: #999" type="file-search" />

          <div style="color: #999; font-size: 16px; margin-top: 20px">
            内容为空
          </div>
        </div>
      </div>

      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 91vh;
          width: 30px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 91vh;
          width: 30px;
        "
      ></div>
    </div>
    <!-- 分页 -->
    <pagingCompont
      :table_scroll_width="table_scroll_width"
      :table_null_width="body_width"
      :r_page="r_page"
      :r_limit="r_limit"
      :table_total="table_total"
      @pagination-Change="paginationChange"
      @change-size-limit="changeSizeLimit"
    ></pagingCompont>

    <!-- 自定义列 -->
    <a-modal
      v-model="custtom_visible"
      width="940px"
      title="设置自定义列"
      @ok="customTd"
      okText="确认"
      cancelText="取消"
      @cancel="cancelClick"
    >
      <div style="max-height: 500px; overflow-y: overlay">
        <template v-for="d_tem in customCheckboxData">
          <div class="custom-title">
            <a-checkbox
              @change="checkboxCustom($event, d_tem)"
              :checked="d_tem.custom_checkbox"
              style="margin-right: 5px; margin-bottom: 7px"
              >{{ d_tem.label }}
              <a-popover v-if="d_tem.type === 'all_roi_index'">
                <template slot="content">
                  <p class="title_text">巨量：付费+平台 IAA指标</p>
                  <p class="title_text">快手：付费+平台native IAP和IAA指标</p>
                </template>
                <a-icon
                  type="question-circle"
                  style="cursor: pointer; margin-left: 2px"
                />
              </a-popover>
            </a-checkbox>
          </div>
          <div class="custom-cell-box">
            <template v-for="(item, index) in copyRableTitle">
              <div
                v-if="d_tem.showTitle.indexOf(item.type) > -1"
                :key="item.type"
                style="width: 280px"
              >
                <a-checkbox
                  @change="onChangeSJ($event, index, d_tem)"
                  :checked="item.show_control"
                  style="margin-right: 5px; margin-bottom: 7px"
                >
                  {{ item.title }}
                </a-checkbox>
              </div>
            </template>
          </div>
        </template>
      </div>
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {
  putDataMenu,
  pitcherStatisList,
  pitcherStatisExport,
} from "@/request/api";
import { getCommonPutTeamList } from "@/request/api.common";
// import JLjhTable from '@/components/JLjhTable.vue'

import {
  diyList,
  rableTitle,
  groupList,
  checkedList,
  checkedListArr,
  roiKeyList,
} from "./const";
export default {
  name: "pitcherStatistics_",
  components: {},
  data() {
    this.dateFormat = "YYYY-MM-DD";
    return {
      locale,
      moment,
      role_control: JSON.parse(localStorage.getItem("role_limits")) || [],
      roiKeyList,
      team_id: undefined,
      checkedList: JSON.parse(JSON.stringify(checkedList)),
      groupList: checkedListArr,
      startTime: "2022-05-01", // 投放日期-开始时间
      endTime: "2022-06-30", // 投放日期-结束时间
      content_type: 1, // 页面内容展现类型
      lastTableTitle: [
        ...JSON.parse(JSON.stringify(groupList)),
        ...JSON.parse(JSON.stringify(rableTitle)),
      ],
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        ...JSON.parse(JSON.stringify(groupList)),
        ...JSON.parse(JSON.stringify(rableTitle)),
      ],
      copyRableTitle: [
        ...JSON.parse(JSON.stringify(groupList)),
        ...JSON.parse(JSON.stringify(rableTitle)),
      ],
      tableShowData: [],
      tableSumData: {}, // 总计
      //   sticky_index: 3, // 表格内需要进行粘性定位的数量
      table_scroll_width: 1600,
      body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
      search_button_loading: false, // 搜索按钮的加载状态
      down_button_loading: false,
      r_page: 1,
      table_total: 0,
      r_limit: 30,
      r_media_platform: undefined, // 媒体平台
      r_admin_id: undefined, // 投手id
      r_group_id: undefined, // 投放小组
      r_sort_field: "", // 要排序的字段
      r_sort_type: "", // 排序方式
      r_user_id: [], // 推广人员ID
      filterData: {
        op_id: {},
        group: {},
      },

      custtom_visible: false, // 自定义列弹窗
      customCheckboxData: JSON.parse(JSON.stringify(diyList)),
      copyCustomCheckboxData: JSON.parse(JSON.stringify(diyList)),
      putTeamList: [],
    };
  },
  mounted() {
    let that = this;

    // that.search_button_loading = true
    that.body_width = document.body.clientWidth - 60; // 筛选条件大盒子的宽度
    that.computeTableWidth();

    // 获取29天前日期
    // that.startTime = this.$getBeforeDay(29)

    // 获取当天
    that.endTime = this.$getThisDay();
    that.startTime = this.$getThisDay();

    putDataMenu().then((res) => {
      that.filterData = res.data.data.filter;
    });

    this.initTeamList();
  },
  computed: {
    calcShowTeamId() {
      if (this.role_control.length === 0) {
        return false;
      }
      return this.role_control.includes(1);
    },
    sticky_index() {
      if (this.checkedList.length === 0) {
        return 0;
      }
      return this.checkedList.length - 1;
    },
  },
  watch: {
    checkedList(val, oldval) {
      if (val && val.length === 0) {
        this.checkedList = JSON.parse(JSON.stringify(oldval));
        this.$message.warning(`至少选择一个汇总条件`);
        return;
      }
      const _temp = groupList.filter((v) => this.checkedList.includes(v.type));
      const _rableTitle = JSON.parse(JSON.stringify(this.rableTitle)).filter(
        (v) => !checkedList.includes(v.type)
      );
      this.rableTitle = [..._temp, ..._rableTitle];
      if (oldval && oldval.length > 0) {
        this.searchButton();
      }
    },
  },
  methods: {
    putTeamChange() {
      this.searchButton();
    },
    initTable() {
      const pitcherStatisticsTable = localStorage.getItem(
        "pitcherStatisticsTable"
      );
      const pitcherStatisticsCheck = localStorage.getItem(
        "pitcherStatisticsCheck"
      );

      if (pitcherStatisticsTable && pitcherStatisticsCheck) {
        // lastTableTitle
        const temp = JSON.parse(pitcherStatisticsTable);
        this.rableTitle = this.lastTableTitle.map((v) => {
          const item = temp.find((value) => value.type === v.type);
          if (item) {
            return {
              ...v,
              sort_control: item.sort_control,
              show_control: item.show_control,
            };
          }
          return v;
        });
        this.copyCustomCheckboxData = JSON.parse(pitcherStatisticsCheck);
      }
      this.$nextTick(() => {
        this.computeTableWidth();
      });
    },
    async initTeamList() {
      this.initTable();
      if (this.calcShowTeamId) {
        const result = await getCommonPutTeamList();
        this.putTeamList = result;
        if (result && result.length > 0) {
          this.team_id = result[0].value;
        }
      }
      this.searchButton();
    },
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 日期选择
    onChangeDate(date, dateString) {
      console.log(date, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },

    // 计算表格宽度
    computeTableWidth() {
      let that = this;
      let nn = 0;
      that.rableTitle.forEach((res, index) => {
        if (res.show_control) {
          nn = nn + res.width;
        }
      });
      const _width = nn + 30 + 30;
      that.table_scroll_width = _width > 1600 ? _width : 1500;
      //   that.table_scroll_width = nn + 30 + 30;
    },

    // 请选择投手
    handleChangeA(e) {
      this.r_admin_id = e;
    },
    handleChangeB(e) {
      this.r_media_platform = e;
    },

    handleChangeT(e) {
      // 投放小组
      this.r_group_id = e;
    },
    // 搜索
    searchButton(type, button_type) {
      let that = this;

      if (type == "button") {
        that.r_page = 1;
      }
      let r_data = {
        limit: that.r_limit,
        page: that.r_page,
        start_date_key: that.startTime.replace(/-/g, ""),
        end_date_key: that.endTime.replace(/-/g, ""),
        // start_date_key: 20210101,
        // end_date_key: 20250201,
        admin_id: that.r_admin_id, // 投手
        media_platform: that.r_media_platform, // 媒体平台
        group_id: that.r_group_id,
        // groupBy
        groupBy: that.checkedList.join(","),
      };
      if (that.calcShowTeamId && that.team_id) {
        r_data.team_id = that.team_id;
      }
      if (that.r_sort_field) {
        r_data.order = that.r_sort_field;
        r_data.sort = that.r_sort_type;
      }

      if (button_type != "导出") {
        that.search_button_loading = true;
        pitcherStatisList(r_data)
          .then((res) => {
            console.log("搜索结果", res);
            that.search_button_loading = false;
            if (
              res.data.code === 0 ||
              res.data.code === 200 ||
              res.data.code == 8011
            ) {
              that.body_width = document.body.clientWidth - 60; // 筛选条件大盒子的宽度
              that.$message.success("搜索成功");
              that.table_total = res.data.data.total;
              that.tableShowData = res.data.data.data;
            } else {
              if (res.data.code === 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }

            // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
            setTimeout(() => {
              document
                .querySelector("body")
                .setAttribute("style", "overflow-x: visible;");
            }, 100);
          })
          .catch((err) => {
            console.log(err);
            that.search_button_loading = false;
            that.$message.error("搜索失败，可能是网络出现问题");
          });
      } else {
        // 导出
        that.down_button_loading = true;
        r_data.report = 1;
        pitcherStatisExport(r_data)
          .then((res) => {
            console.log("导出测试", res);
            that.down_button_loading = false;
            if (
              res.data.code == 0 ||
              res.data.code == 200 ||
              res.data.code == 8011
            ) {
              that.$message.success(res.data.msg || "导出成功");
            } else {
              if (res.data.code == 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          })
          .catch((error) => {
            that.down_button_loading = false;
          });
      }
    },
    // 导出
    exportButton() {
      this.searchButton("", "导出");
    },
    // 点击表格表头，筛选排序
    tableThClick(index, status, type) {
      let that = this;
      console.log(index, status, type);
      if (status == 0) {
        // 默认
        that.r_sort_field = "";
        that.r_sort_type = "";
      } else if (status == 1) {
        // desc
        that.r_sort_field = type;
        that.r_sort_type = "desc";
      } else if (status == 2) {
        // asc
        that.r_sort_field = type;
        that.r_sort_type = "asc";
      }

      that.searchButton();
    },
    sortClick(index) {
      // 点击表头给内容进行排序
      let that = this;
      let th_status; // 0是默认，1是箭头向下，2是箭头向上

      if (that.rableTitle[index].sort_control) {
        // 是否有排序功能
        if (index !== this.select_sort_index) {
          this.select_sort_index = index;
          that.rableTitle.forEach((res) => {
            res.sort_status = 0;
          });
          that.rableTitle[index].sort_status = 1;
          th_status = 1;
        } else {
          // 点击的是同一个表头
          if (that.rableTitle[index].sort_status === 0) {
            that.rableTitle[index].sort_status = 1; // 箭头向下
            th_status = 1;
          } else if (that.rableTitle[index].sort_status === 1) {
            that.rableTitle[index].sort_status = 2; // 箭头向上
            th_status = 2;
          } else if (that.rableTitle[index].sort_status === 2) {
            that.rableTitle[index].sort_status = 0;
            th_status = 0;
          }
        }
        that.tableThClick(index, th_status, that.rableTitle[index].type);
      }
    },

    // 数据项————————
    onChangeSJ(e, index, d_tem) {
      this.copyRableTitle[index].show_control = e.target.checked;
      // 重新计算表格宽度
      this.computeTableWidth();
      // 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
      let ccccc = true;
      d_tem.showTitle.forEach((res) => {
        this.copyRableTitle.forEach((t_es) => {
          if (res == t_es.type && !t_es.show_control) {
            ccccc = false;
          }
        });
      });
      d_tem.custom_checkbox = ccccc;
    },
    // 开启自定义弹框
    showCusttomTable() {
      this.copyRableTitle = JSON.parse(JSON.stringify(this.rableTitle));
      this.customCheckboxData = JSON.parse(
        JSON.stringify(this.copyCustomCheckboxData)
      );
      this.custtom_visible = true;
    },
    // 自定义列的小标题前的选择框
    checkboxCustom(e, d_tem) {
      d_tem.custom_checkbox = e.target.checked;
      this.copyRableTitle.forEach((res) => {
        d_tem.showTitle.forEach((d_es) => {
          if (res.type == d_es) {
            if (e.target.checked) {
              // 要进行选中
              res.show_control = true;
            } else {
              res.show_control = false;
            }
          }
        });
      });
      // 重新计算表格宽度
      this.computeTableWidth();
    },

    // 自定义列弹窗确认按钮
    customTd() {
      this.rableTitle = JSON.parse(JSON.stringify(this.copyRableTitle));
      this.custtom_visible = false;
      this.copyCustomCheckboxData = JSON.parse(
        JSON.stringify(this.customCheckboxData)
      );
      localStorage.setItem(
        "pitcherStatisticsTable",
        JSON.stringify(this.copyRableTitle)
      );
      localStorage.setItem(
        "pitcherStatisticsCheck",
        JSON.stringify(this.customCheckboxData)
      );
      this.$nextTick(() => {
        this.computeTableWidth();
      });
    },
    // 自定义列弹窗取消按钮
    cancelClick() {
      this.custtom_visible = false;
      this.customCheckboxData = JSON.parse(
        JSON.stringify(this.copyCustomCheckboxData)
      );
    },
    // 分页
    paginationChange(e) {
      let that = this;
      this.r_page = e;
      that.searchButton();
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },
  },
  filters: {
    dayToFixed(e) {
      // 保留小数点后两位，四舍五入
      // console.log("过滤器",e)
      if (Object.keys(e).length > 0) {
        let v = Number(e.charge_money) / Number(e.cost);
        return v.toFixed(2);
      } else {
        return "-";
      }
    },
    tableToFixed(value) {
      // 保留小数点后两位，四舍五入
      // console.log("过滤器",value)
      if (value) {
        let v = Number(value);
        return v.toFixed(2);
      } else {
        return 0;
      }
    },
    mediaFilters(e) {
      // 媒体平台
      let fff = "";
      if (e == 1) {
        fff = "巨量";
      } else if (e == 2) {
        fff = "腾讯ADQ";
      } else if (e == 3) {
        fff = "腾讯MP";
      } else if (e == 4) {
        fff = "百度";
      } else if (e == 5) {
        fff = "快手";
      } else {
        fff = "其他";
      }
      return fff;
    },
    planFilters(e) {
      // 计划类型
      let fff = "";
      if (e == 1) {
        fff = "巨量1.0";
      } else if (e == 2) {
        fff = "巨量2.0";
      } else if (e == 3) {
        fff = "ADQ广告";
      } else if (e == 4) {
        fff = "MP广告";
      } else if (e == 5) {
        fff = "百度单元";
      } else if (e == 6) {
        fff = "快手广告组";
      } else {
        fff = "其他";
      }
      return fff;
    },
  },
};
</script>

<style scoped>
.title-tab-box {
  color: #313a46;
  padding: 8px 20px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.title-tab-box-selected {
  color: #62a8ea;
  border: 1px solid #62a8ea;
}

/* 当表头有排序功能时加上这两个参数 */
.table-th-cell:hover {
  background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky {
  background-color: #eee;
}
.table-th-cell {
  min-height: 40px;
}

.custom-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}
.custom-cell-box {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  margin-bottom: 20px;
}
.page_title_div {
  display: flex;
}
.page_select {
  position: sticky;
  left: 0px;
  width: 150px;
}
.page_title {
  position: sticky;
  left: 30px;
  z-index: 5;
  margin-bottom: 10px;
}

.group_div {
  display: flex;
  align-items: center;
}
.disabled_div {
  color: rgba(0, 0, 0, 0.8);
  background-color: #f5f5f5;
  display: flex;
  width: 80px;
  align-items: center;
  justify-content: center;
  height: 34px;
  position: sticky;
  left: 30px;
}
.title_text {
  position: relative;
  padding-left: 16px;
  margin-bottom: 4px;
}
.title_text::before {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: #1684fc;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>
